// extracted by mini-css-extract-plugin
export default {"title":"styles_title__qnNJO","sub_title":"styles_sub_title__tKNWV","title_container":"styles_title_container__sQQIW"};